var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v(_vm._s(_vm.title))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "vs-table",
        {
          ref: "tableSelect",
          attrs: {
            search: "",
            "max-items": _vm.maximoItems == "" ? 20 : _vm.maximoItems,
            data: _vm.registros,
            pagination: ""
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var data = ref.data
                return _vm._l(data, function(tr, index) {
                  return _c(
                    "vs-tr",
                    { key: index, attrs: { data: tr } },
                    [
                      _c("vs-td", [
                        _c("div", [
                          _c(
                            "label",
                            { attrs: { for: "seleccionar" + index } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.seleccionados,
                                    expression: "seleccionados"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "seleccionar" + index
                                },
                                domProps: {
                                  value: tr,
                                  checked: Array.isArray(_vm.seleccionados)
                                    ? _vm._i(_vm.seleccionados, tr) > -1
                                    : _vm.seleccionados
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.seleccionados,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = tr,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.seleccionados = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.seleccionados = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.seleccionados = $$c
                                    }
                                  }
                                }
                              }),
                              _c("span")
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.columnas, function(columna) {
                        return _c(
                          "vs-td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !columna.hidden,
                                expression: "!columna.hidden"
                              }
                            ],
                            key: columna.nombre + index,
                            attrs: {
                              data: _vm.lodash.get(data[index], columna.nombre)
                            }
                          },
                          [
                            _vm.saldoSeleccionable &&
                            columna.nombre == _vm.columnaPago &&
                            _vm.seleccionados.includes(tr)
                              ? _c("span", [
                                  _c(
                                    "div",
                                    { staticClass: "form-field" },
                                    [
                                      _c("input-field", {
                                        attrs: {
                                          id: columna.nombre + index,
                                          placeholder: "Seleccione...",
                                          vMoney: "",
                                          format: _vm.money
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.validarSaldo(index)
                                          }
                                        },
                                        model: {
                                          value: data[index][columna.nombre],
                                          callback: function($$v) {
                                            _vm.$set(
                                              data[index],
                                              columna.nombre,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data[index][columna.nombre]"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : columna.link
                              ? _c("span", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-info btn--text",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "visitarLink",
                                            data[index],
                                            columna.nombre
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.lodash.get(
                                              data[index],
                                              columna.nombre
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        columna.money
                                          ? _vm.moneyFormat(
                                              _vm.lodash.get(
                                                data[index],
                                                columna.nombre
                                              )
                                            )
                                          : _vm.lodash.get(
                                              data[index],
                                              columna.nombre
                                            )
                                      ) +
                                      "\n                    "
                                  )
                                ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              }
            }
          ])
        },
        [
          _c("template", { slot: "header" }, [
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c(
                  "input-field",
                  {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "###",
                        expression: "'###'"
                      }
                    ],
                    staticClass: "input-field--stretch ml-3",
                    attrs: { type: "tel", id: "maximoItems", placeholder: "" },
                    model: {
                      value: _vm.maximoItems,
                      callback: function($$v) {
                        _vm.maximoItems = $$v
                      },
                      expression: "maximoItems"
                    }
                  },
                  [_c("span", [_vm._v("Cantidad de registros:")])]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "seleccionados" } }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.seleccionados.length) +
                        " registro(s) seleccionado(s)."
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", [
                _c("div", [
                  _c("label", { attrs: { for: "seleccionar_todos" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.seleccionar_todos,
                          expression: "seleccionar_todos"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "seleccionar_todos",
                        id: "seleccionar_todos"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.seleccionar_todos)
                          ? _vm._i(_vm.seleccionar_todos, null) > -1
                          : _vm.seleccionar_todos
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.seleccionar_todos,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.seleccionar_todos = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.seleccionar_todos = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.seleccionar_todos = $$c
                            }
                          },
                          _vm.changeSeleccionarTodos
                        ]
                      }
                    }),
                    _c("span", [_c("br")])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.columnas, function(columna) {
                return _c(
                  "vs-th",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !columna.hidden,
                        expression: "!columna.hidden"
                      }
                    ],
                    key: columna.nombre,
                    attrs: {
                      "sort-key": columna.sortable ? columna.nombre : null
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(columna.descripcion) +
                        "\n            "
                    )
                  ]
                )
              })
            ],
            2
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          {
            staticClass: "btn-success",
            attrs: { type: "button" },
            on: { click: _vm.seleccionar }
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _c("span", [_vm._v("Seleccionar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn-danger btn--text", on: { click: _vm.cerrar } },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cerrar")])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49393dc6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49393dc6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/KTableSelect.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-49393dc6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/KTableSelect.vue
// module chunks = 0